import { Loading, MessageBox, Message, Notification } from "element-ui";
export default function Alert(Vue) {
  //警告提示
  Vue.prototype.$tip = function (message) {
    Message({ type: "warning", message: message || "警告提示" });
  };
  //错误提示
  Vue.prototype.$error = function (message) {
    Message({ type: "error", message: message || "错误提示" });
  };
  //加载
  Vue.prototype.$loading = function (param) {
    //loading.close();
    return Loading.service({
      ...param,
    });
  };

  Vue.prototype.$imgLoading = (imgsrc) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        resolve({
          width: img.width,
          height: img.height,
          per: img.width / img.height,
        });
      };
      img.onerror = reject;
      img.src = imgsrc;
    });
  };
  Vue.prototype.$convertLatLonToPixel = (
    longitude,
    latitude,

    mapWidth,
    mapHeight,
    zoom
  ) => {
    var x = (longitude + 180) * (mapWidth / 360); //14

    var y = (90 - latitude) * (mapHeight / 180); //110

    return { x: x, y: y };
  };
}
